module.exports = __webpack_public_path__ + "static/media/laptopImg.cb3f9a31.webp";